import { render, staticRenderFns } from "./HelpCenterNav.vue?vue&type=template&id=7defa945&scoped=true&"
import script from "./HelpCenterNav.vue?vue&type=script&lang=js&"
export * from "./HelpCenterNav.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterNav.vue?vue&type=style&index=0&id=7defa945&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7defa945",
  null
  
)

export default component.exports